declare global {
  let Badge: any;
  interface Window {
    Badge: any;
  }
}

export function extendBadge() {
  if (lib.comsuntexsymbolsBadge) {
    window.Badge = lib.comsuntexsymbolsBadge;

    const comsuntexsymbolsBadge_constructor = lib.comsuntexsymbolsBadge;
    const comsuntexsymbolsBadge_prototype = lib.comsuntexsymbolsBadge.prototype;

    lib.comsuntexsymbolsBadge = function () {
      this._oldConstructor = comsuntexsymbolsBadge_constructor;
      this._oldConstructor();

      this.bg = null;

      this.levelIcon.visible = false;
      this.playerIcon.visible = false;
    };
    lib.comsuntexsymbolsBadge.prototype = comsuntexsymbolsBadge_prototype;

    const p = lib.comsuntexsymbolsBadge.prototype;

    p.bg = null;

    p.display = function (stickers, icon, color, type) {
      //TestUtil.log("display:"+stickers, icon, color, type);
      if (type == null) type = Badge.PLAYER;

      if (stickers == null) {
        TestUtil.warn("'stickers' is not defined");
        stickers = 0;
      }

      UIUtil.setFrame(this.shine, type);

      if (icon <= 0) {
        if (stickers > 0 && color > 0) this.displaySkillBadge(stickers, type);
      } else {
        //UIUtil.delay(this.setPlayerIcon,50,[icon]);
        this.setPlayerIcon(icon);
        this.setBackgroundColor(color, type);
      }
    };

    p.displaySkillBadge = function (stickers, type) {
      //TestUtil.log("displaySkillBadge:"+stickers,type);
      if (type == null || type < 1) type = Badge.PLAYER;
      const props = Badge.getSkillBadgeProperties(stickers);

      UIUtil.setFrame(this.shine, type);
      this.setLevelIcon(props.level);
      this.setBackgroundColor(Badge.LEVEL_COLORS[props.colorIndex], type);
      UIUtil.setFrame(this.shapeOutline, props.shapeFrame + type * 10);
    };

    p.setBackgroundColor = function (color, type) {
      //TestUtil.log("setBackgroundColor:"+color,type);
      //TestUtil.logObject(this);
      if (type == null) type = Badge.PLAYER;

      if (this.bg) {
        this.removeChild(this.bg);
      }

      this.bg = GraphicsUtil.createSprite();
      this.stop();

      this.bg.name = 'bg';

      GraphicsUtil.beginFill(this.bg, GraphicsUtil.toColor(color));

      switch (type) {
        case 2:
          GraphicsUtil.drawRect(this.bg, -70, -70, 140, 140);
          break;
        case 3:
          GraphicsUtil.drawPolygon(this.bg, 5, 80, -Math.PI / 2, 0, 10);
          break;
        default:
          GraphicsUtil.drawCircle(this.bg, 80, 0, 0);
      }

      this.addChildAt(this.bg, 0);
      if (this.levelIcon) UIUtil.bringToFront(this.levelIcon);
      if (this.playerIcon) UIUtil.bringToFront(this.playerIcon);
      window.stage?.update();
    };

    p.setPlayerIcon = function (i) {
      if (i > 100) {
        if (this.levelIcon) this.levelIcon.visible = true;
        if (this.playerIcon) this.playerIcon.visible = false;
        UIUtil.setFrame(this.levelIcon, i - 100);
        //GraphicsUtil.shadow(this.levelIcon);
      } else {
        if (this.levelIcon) this.levelIcon.visible = false;
        if (this.playerIcon) {
          this.playerIcon.visible = true;
        }
        //UIUtil.delay(UIUtil.setFrame, 50, [this.playerIcon, i]);
        UIUtil.setFrame(this.playerIcon, i);
        //GraphicsUtil.shadow(this.playerIcon);
      }
      UIUtil.setFrame(this.shapeOutline, 1);

      if (this.levelIcon) UIUtil.bringToFront(this.levelIcon);
      if (this.playerIcon) UIUtil.bringToFront(this.playerIcon);

      window.stage?.update();
    };

    p.setLevelIcon = function (i) {
      //TestUtil.log("setLevelIcon"+i);
      this.levelIcon.visible = true;
      this.playerIcon.visible = false;

      if (this.levelIcon) UIUtil.bringToFront(this.levelIcon);
      if (this.playerIcon) UIUtil.bringToFront(this.playerIcon);

      //UIUtil.delay(UIUtil.setFrame, 50, [this.levelIcon, i]);
      UIUtil.setFrame(this.levelIcon, i);
      //GraphicsUtil.shadow(this.levelIcon);

      window.stage?.update();
    };

    /* static */

    Badge.getSkillBadgeProperties = function (stickers) {
      if (stickers == null) TestUtil.warn("'stickers' is not defined");
      const props = {} as any;
      const level = Badge.getSkillLevel(stickers);

      if (level > 10) {
        props.shapeFrame = 7;
        props.shapePercent = 100;
        props.colorIndex = 6;
        props.colorPercent = 100;
      } else {
        props.shapePercent =
          (stickers - Badge.LEVEL_THRESHHOLDS[level - 1]) /
          (Badge.LEVEL_THRESHHOLDS[level] - Badge.LEVEL_THRESHHOLDS[level - 1]);
        if (stickers == 0) props.shapePercent = 0;
        props.shapeFrame = Math.ceil(props.shapePercent * 6);
        if (props.shapeFrame == 0) props.shapeFrame = 1;

        props.colorPercent = props.shapePercent * 6 - props.shapeFrame + 1;
        if (props.colorPercent >= 1) props.colorPercent = 0;
        props.colorIndex = Math.floor(props.colorPercent * 6);
        if (props.colorIndex == 6) props.colorIndex = 5;
      }

      props.level = level;

      return props;
    };

    Badge.getSkillLevel = function (stickers) {
      for (
        var level = 1;
        stickers >= Badge.LEVEL_THRESHHOLDS[level];
        level++
      ) {}
      if (level > 10) level = 1 + Math.floor(stickers / 1000);
      return level;
    };

    Badge.LEVEL_THRESHHOLDS = [
      0, 250, 500, 1000, 1500, 2000, 3000, 4000, 5500, 7500, 10000,
    ];
    Badge.LEVEL_COLORS = [
      0x00bb66, 0xcc0033, 0x0066ff, 0x993300, 0xcccccc, 0xffbb22, 0x552266,
    ];

    Badge.PLAYER = 1;
    Badge.TEAM = 2;
    Badge.SCHOOL = 3;

    Badge.BADGE_WIDTH = 180;
  }
}
